/** Read display width as a percentage of the editor (10–100). */
export function readImageWidthPercent(img, editorRoot) {
  if (!img) return 100;
  const styleWidth = img.style?.width ?? "";
  if (styleWidth.endsWith("%")) {
    const n = parseFloat(styleWidth);
    if (Number.isFinite(n)) return clampWidthPercent(n);
  }
  if (styleWidth.endsWith("px")) {
    const px = parseFloat(styleWidth);
    const editorWidth = editorRoot?.clientWidth || img.parentElement?.clientWidth || 600;
    if (Number.isFinite(px) && editorWidth > 0) {
      return clampWidthPercent(Math.round((px / editorWidth) * 100));
    }
  }
  const attrWidth = img.getAttribute("width");
  if (attrWidth && /^\d+$/.test(attrWidth)) {
    const px = Number(attrWidth);
    const editorWidth = editorRoot?.clientWidth || 600;
    if (editorWidth > 0) return clampWidthPercent(Math.round((px / editorWidth) * 100));
  }
  return 100;
}

export function clampWidthPercent(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 100;
  return Math.min(100, Math.max(10, Math.round(n)));
}

/** Apply width as a percentage; height stays proportional. */
export function applyImageWidthPercent(img, widthPercent) {
  if (!img) return;
  const pct = clampWidthPercent(widthPercent);
  img.style.width = `${pct}%`;
  img.style.height = "auto";
  img.style.maxWidth = "100%";
  img.removeAttribute("width");
  img.removeAttribute("height");
}
